import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Bar = _resolveComponent("Bar");
    return ($data.data)
        ? (_openBlock(), _createBlock(_component_Bar, {
            key: 0,
            data: $data.data,
            options: $data.options
        }, null, 8, ["data", "options"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Loading ")
        ], 64));
}
